import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { forkJoin } from 'rxjs';
import { GetEmpty } from 'src/app/classes/Empties';
import {Utils} from 'src/app/classes/Utils';
import { CashCloseInfo } from 'src/app/models/models';
import {Cash_Close, Currency_Rate, Store} from 'src/app/models/RestModels';
import {BaseComponent} from 'src/app/pages/base/base.component';
import { CashCloseReportService } from 'src/app/services/cash-close-report.service';
import { PrinterService, shouldPrintCashCloseUsb } from 'src/app/services/printer.service';

// Wait after a successful USB print before closing the session,
// so the print fully completes and the success message is visible.
export const CASH_CLOSE_LOGOUT_DELAY_MS = 2000;

@Component
({
	selector: 'app-save-cash-close',
	templateUrl: './save-cash-close.component.html',
	styleUrls: ['./save-cash-close.component.css']
})

export class SaveCashCloseComponent extends BaseComponent implements OnInit
{
	cash_close_list:Cash_Close[] = [];
	cash_on_hand: '' | number = '';
	cash_dolares:'' | number = '' ;
	currency_rate_list:Currency_Rate[] = [];
	store: Store = GetEmpty.store();
	show_detailed_cash_close: boolean = false;
	cash_inputs: { [key: string]: number } = {};

	@Output() close = new EventEmitter<boolean>();

	private printerService: PrinterService;
	private cashCloseReport: CashCloseReportService;

	constructor(public injector: Injector) {
		super(injector);
		this.printerService = injector.get(PrinterService);
		this.cashCloseReport = injector.get(CashCloseReportService);
	}

	ngOnInit(): void
	{
		this.subs.sink = forkJoin
		({
			store: this.rest.store.get( this.rest.current_user.store_id ),
			cash_close: this.rest.cash_close.search
			({
				eq:{ created_by_user_id: this.rest.current_user.id },
				sort_order: ['id_DESC'],
				limit: 7
			}),
			currency_rate: this.rest.currency_rate.search
			({
				eq:{ store_id: this.rest.current_user.store_id },
				limit: 99999
			})
		})
		.subscribe
		({
			error:(error)=>this.showError(error),
			next:(response)=>
			{
				this.cash_close_list = response.cash_close.data;
				this.currency_rate_list = response.currency_rate.data;
				this.store = response.store;
			}
		});
	}

	getSubtotal(field: string, denomination: number)
	{
		let form = document.forms.namedItem('cash-close') as HTMLFormElement;
		let raw = form?.elements.namedItem(field) as HTMLInputElement;
		let value = parseInt(raw?.value || '0', 10);

		return isNaN(value) ? 0 : value * denomination;
	}

	getTotalCashCountForm(prefix: string, type: string): number
	{
		let form = document.forms.namedItem('cash-close') as HTMLFormElement;
		if (!form) return 0;

		let total = 0;
		let elements = Array.from(form.elements) as HTMLInputElement[];

		for (let el of elements)
		{
			if (!el.name || !el.name.startsWith(prefix)) continue;

			let parts = el.name.split('_');
			if (parts.length < 3) continue;

			let denomination = parseFloat(parts[1].replace(',', '.'));
			let qty = parseInt(el.value || '0', 10);
			let el_type = parts[2]; // 'bill' o 'coin'

			if (el_type !== type) continue;

			if (!isNaN(denomination) && !isNaN(qty))
			{
				total += denomination * qty;
			}
		}

		return total;
	}


	getTotalInMXNCashCountForm(prefix: string, type: string)
	{
		let usd_total = this.getTotalCashCountForm(prefix, type);
		let usd_rate = this.rest.getExchangeRate(
			this.store.default_currency_id,
			this.store.default_currency_id,
			'USD',
			this.currency_rate_list
		);

		return usd_total * usd_rate;
	}

	onCashCloseSubmit(evt: Event): void
	{
		console.log('Creando corte', Math.random());
		let date:string = Utils.getMysqlStringFromLocalDate( new Date() );
		this.is_loading = true;

		let other_currencies = parseFloat( ''+this.cash_dolares );
		let cash_on_hand = parseFloat( ''+this.cash_on_hand );
		let total_cash = 0;

		if (isNaN(cash_on_hand)) cash_on_hand = 0;
		if (isNaN(other_currencies)) other_currencies = 0;

		let order_currency_id = this.store.default_currency_id;
		let default_currency_id = this.store.default_currency_id;
		let target_currency_id = this.store.default_currency_id;

		let pesos_rate = this.rest.getExchangeRate
		(
			order_currency_id,
			default_currency_id,
			'MXN', //target_currency_id,
			this.currency_rate_list
		)

		let dolares_rate = this.rest.getExchangeRate
		(
			order_currency_id,
			default_currency_id,
			'USD', //target_currency_id,
			this.currency_rate_list
		);

		let cash_close: Partial<Cash_Close>;
		let payload: any = {};

		if (this.rest.local_preferences.default_cash_close_type === 'DETAILED')
		{
			let form = evt.target as HTMLFormElement;
			let formData = new FormData(form);

			let cash_counts: any[] = [];
			let physical_total_mxn = 0;
			let physical_total_usd = 0;

			formData.forEach((value, key) =>
			{
				let parts = key.split('_');
				let type = parts.slice(2).join('_').toUpperCase();
				let is_virtual = ['CREDIT_CARD', 'DEBIT_CARD', 'CHECK', 'TRANSFER'].includes(type);
				let qty = is_virtual ? parseFloat(value as string) : parseInt(value as string, 10);

				if (!qty || qty <= 0) return;

				let currency_id = parts[0].toUpperCase();
				let denomination = parseFloat(parts[1].replace(',', '.'));
				let subtotal = denomination * qty;

				if (is_virtual)
				{
					cash_counts.push({
						cash_close_id: null,
						currency_id,
						denomination: qty,
						quantity: 1,
						type,
						only_reference: '1'
					});
				}
				else
				{
					if (currency_id === 'MXN') physical_total_mxn += subtotal;
					if (currency_id === 'USD') physical_total_usd += subtotal;

					cash_counts.push({
						cash_close_id: null,
						currency_id,
						denomination,
						quantity: qty,
						type,
						only_reference: '0'
					});
				}
			});

			let total = physical_total_mxn + (physical_total_usd * dolares_rate);

			cash_close = {
				end: date,
				cash_on_hand: total,
				other_currencies: physical_total_usd,
				note: 'Dólares ' + physical_total_usd.toFixed(2) + ' x ' + dolares_rate.toFixed(5)
			};

			console.log('Detalle del corte:', cash_counts);

			payload = {
				cash_close,
				cash_counts
			};
		}
		else
		{
			let total = pesos_rate * cash_on_hand + other_currencies * dolares_rate;

			cash_close = {
				end: date,
				cash_on_hand: total,
				other_currencies: 0,
				note: 'Dólares ' + other_currencies.toFixed(2) + ' x ' + dolares_rate.toFixed(5)
			};

			payload = {
				cash_close,
				funds: [] // necesario para no romper la firma anterior
			};
		}

		this.subs.sink = this.rest.cash_close_info
		.create(payload)
		.subscribe((response) =>
		{
			this.showSuccess('Corte exitoso');

			let cash_close_info: CashCloseInfo = response;
			this.printCashCloseAfterCreate(evt, cash_close_info);
		},
		(error) => {
			this.showError(error);
			this.is_loading = false;
		});
	}

	printCashCloseAfterCreate(evt: Event, cash_close_info: CashCloseInfo): void
	{
		const prefs = this.printerService.resolvePreferences(this.rest.current_user);

		if (shouldPrintCashCloseUsb(prefs, cash_close_info.cash_close.id))
		{
			this.printCashCloseUsb(evt, cash_close_info)
				.catch((error) =>
				{
					console.error('USB cash close print failed, falling back to browser print:', error);
					this.showError('Error al imprimir por USB, abriendo impresión normal: ' + (error?.message || 'Error desconocido'));
					this.openPrintWindow(cash_close_info);
				});
			return;
		}

		this.openPrintWindow(cash_close_info);
	}

	async printCashCloseUsb(evt: Event, cash_close_info: CashCloseInfo): Promise<void>
	{
		if (this.printerService.available_printers.length === 0)
		{
			const storeId = this.store?.id || this.rest.current_user?.store_id;
			if (storeId)
			{
				const response = await this.rest.printer.search({
					limit: 9999,
					eq: { store_id: storeId },
					sort_order: ['name_ASC']
				}).toPromise();
				this.printerService.available_printers = response.data;
			}
		}

		if (!this.printerService.isUsbPrintingEnabled())
		{
			throw new Error('No hay impresora USB configurada. Configure la impresora en ajustes.');
		}

		const prefs = this.printerService.resolvePreferences(this.rest.current_user);
		const printer = this.printerService.available_printers.find(p => p.id === prefs.pos_printer_id);

		if (!printer)
		{
			throw new Error('La impresora configurada no existe en esta sucursal. Revise la configuración.');
		}

		const report = await this.cashCloseReport.getReport(cash_close_info.cash_close.id).toPromise();
		const result = await this.printerService.printCashClose(report.ticket_data, 1, evt);

		if (!result.success)
		{
			throw new Error(result.message);
		}

		this.showSuccess('Corte impreso correctamente');
		this.is_loading = false;

		// Same end-of-shift semantics as the /1/1 print window: close the
		// session and send this window back to '/' like the logout broadcast does.
		setTimeout(() => {
			this.rest.logout(false);
			setTimeout(() => { window.location.href = '/'; }, 1000);
		}, CASH_CLOSE_LOGOUT_DELAY_MS);
	}

	openPrintWindow(cash_close_info: CashCloseInfo): void
	{
		let url = `#/print-corte/${this.rest.local_preferences.default_cash_close_receipt}/${cash_close_info.cash_close.id}/1/1`;
		let w = window.open(url);

		w.onafterprint = function()
		{
			console.log('En la funcion foo FOOOO');
	//		z.rest.logout();
		};

		w.addEventListener('afterprint',(_evt2:Event)=>
		{
			console.log('Tratando afterprint');
	//		this.rest.logout();
		});
	}

	closeModal()
	{
		this.close.emit(false);
	}
}

